import { api } from "boot/axios";

import useAcc from "src/use/accounts";

export function whoAmI({ commit }) {
  return new Promise((resolve, reject) => {
    useAcc()
      .whoAmI()
      .then((response) => {
        commit("updateWhoAmI", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error({ error });
        reject(error);
      });
  });
}
